// extracted by mini-css-extract-plugin
export default {"infoButton":"infoBtn_infoButton__MpfRP"};